import { CSSProperties } from "react";

const card: CSSProperties = {
  padding: 2
}

export {
  card
}